import { ConditionalLink } from '@app/common/src/components/conditional-link'
import { ExpandMore } from '@mui/icons-material'
import { MenuAnchor } from './menu-anchor'
import { MenuItemData, isMenuItemLink } from '../menu-item-data'
import { MenuListItem } from './styled'
import { Submenu } from './submenu'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { forwardRef } from 'react'
import { useMenuItem } from '../hooks/use-menu-item'
import styled from 'styled-components'

type MenuListItemProps = {
  menuItem: MenuItemData
}

const StyledText = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`
const StyledExpandMore = styled(ExpandMore)`
  font-size: 20px;
  margin-left: 5px;
`
export const MenuItem = forwardRef<HTMLLIElement, MenuListItemProps>(
  ({ menuItem }, ref): JSX.Element => {
    const { onMenuClick, onMouseEnter, onKeyDown, hasPopup, isExpanded, className, role } =
      useMenuItem({ menuItem })

    return isMenuItemLink(menuItem) ? (
      <MenuListItem ref={ref} role={role} onClick={onMenuClick} onKeyDown={onKeyDown} tabIndex={0}>
        <ConditionalLink condition={true} href={menuItem.href} prefetch={false}>
          <MenuAnchor menuItem={menuItem}>
            <StyledText variant="body/medium" color="inherit" textAlign="center">
              {menuItem.label}
            </StyledText>
          </MenuAnchor>
        </ConditionalLink>
      </MenuListItem>
    ) : (
      <MenuListItem
        ref={ref}
        role={role}
        aria-haspopup={hasPopup}
        aria-expanded={isExpanded}
        className={className}
        onClick={onMenuClick}
        onKeyDown={onKeyDown}
        onMouseEnter={onMouseEnter}
        tabIndex={0}
      >
        <StyledText
          variant="body/medium"
          color="inherit"
          textAlign="center"
          component="div"
          display="flex"
          alignItems="center"
        >
          {menuItem.label}
          <StyledExpandMore className="expand" />
        </StyledText>
        <Submenu menuItem={menuItem} />
      </MenuListItem>
    )
  }
)

MenuItem.displayName = 'MenuItem'
